// ----------------------------------------------------------------------

export const ICON_SIZE = {
    width: 22,
    height: 22,
};
